import axios from "axios";

export const state = {
  cached: "",
};

export const getters = {};

export const mutations = {};

export const actions = {

async authBlob({ commit }, { address }) {
  try {
    const response = await axios.post(`/auth/blob`, { address });
    if (response.data?.object?.blob) {
      return response.data.object.blob; // only return blob
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},

async authLogin({ commit }, { address, signBlob, publicKey }) {
  try {
    const response = await axios.post(`/auth/login`, {
      address,
      signBlob,
      publicKey
    });

    if (response.data?.object?.accessToken) {
      const { accessToken, role } = response.data.object;

      sessionStorage.setItem("accessToken", accessToken);
      sessionStorage.setItem("userRole", role);

      axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
      axios.defaults.headers.common["role"] = role;

      return accessToken; // return token if needed
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},

async statusKyc() {
  try {
    const response = await axios.get(`/issuer/kyc/status`);

    if (response.data?.object?.status !== undefined) {
      return response.data.object.status; // null or PENDING/ACTIVE/REJECTED/REVOKED
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},

async kycDetails({ commit },data) {
     console.log("kycDetails:", data)
  try {
    const response = await axios.post(`/issuer/kyc/address`, data);

    if (response.data?.object) {
      return response.data; 
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},

async registerKYC({ commit }, kycData) {
  try {
    const response = await axios.post(`/issuer/kyc/register`, kycData);

    if (response.data?.object) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},

async uploadFile({ commit }, file) {
  try {
    if (!file) throw new Error("No file provided");

    const formData = new FormData();
    formData.append("file", file); // name must match backend @RequestParam("file")

    const response = await axios.post(`/file/upload`, formData, {
      headers: {
        // Let Axios set the boundary automatically
        "Content-Type": "multipart/form-data"
      }
    });

    if (response.data?.object?.fileId) {
      return response.data.object.fileId; // Return fileId from backend
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      throw new Error(error.response.data.messages[0]);
    }
    throw error;
  }
},


async templateList({ commit }, templateListData) {
  try {
    const response = await axios.post(`/issuer/template/list`, templateListData);

    if (response.data?.object) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},

async templateDetails({ commit }, templateId) {
  try {
    const response = await axios.get(`/issuer/template/detail`, {
      params: { templateId }
    });

    if (response.data?.object) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},



async templateCreate({ commit }, templateCreateData) {
  try {
    const response = await axios.post(`/issuer/template/blob/create`, templateCreateData);

    if (response.data?.object) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},

async templateBlob({ commit }, payload) {
  try {
    // send payload directly, not wrapped
    const response = await axios.post(`/issuer/template/blob/submit`, payload);

    if (response.data?.object) {
      return response.data
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},

async templateApprove({ commit }, payload) {
  try {
    // send payload directly, not wrapped
    const response = await axios.post(`/issuer/template/approve`, payload);

    if (response.data?.object) {
      return response.data
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},


async certList({ commit }, certListData) {
  try {
    const response = await axios.post(`/issuer/certificate/list`, certListData);

    if (response.data?.object) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},

async certDetails({ commit }, vcId) {
  try {
    const response = await axios.post(`/issuer/certificate/detail`, vcId);

    if (response.data?.object) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},

async s3FileUpload({ commit }, file) {
  try {
    if (!file) throw new Error("No file provided");

    const formData = new FormData();
    formData.append("file", file); // backend expects @RequestParam("file")

    const response = await axios.post(`/s3/file/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });

    // ✅ Backend returns the URL string directly inside `object`
    if (response.data?.object) {
      return response.data.object; // return the S3 file URL
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      throw new Error(error.response.data.messages[0]);
    }
    throw error;
  }
},

async vcPassCreate({ commit }, data) {
  try {
    const response = await axios.post(`/issuer/pass-design/blob/create`, data);

    if (response.data?.object) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},

async vcPassBlob({ commit }, data) {
  try {
    // send payload directly, not wrapped
    const response = await axios.post(`/issuer/pass-design/blob/submit`, data);

    if (response.data?.object) {
      return response.data; // return blob object
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},

async vcPassDetails({ commit }, templateId) {
  try {
    const response = await axios.get(`/issuer/pass-design/detail`, {
      params: { templateId }
    });

    if (response.data?.object) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},


async vcPassList({ commit }, templateListData) {
  try {
    const response = await axios.post(`/issuer/pass-design/list`, templateListData);

    if (response.data?.object) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},

async vcPassApprove({ commit }, payload) {
  try {
    // send payload directly, not wrapped
    const response = await axios.post(`/issuer/pass-design/issuer/approve`, payload);

    if (response.data?.object) {
      return response.data
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},

async vcPassListAdmin({ commit }, templateListData) {
  try {
    const response = await axios.post(`/issuer/pass-design/admin/list`, templateListData);

    if (response.data?.object) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},

async kycList({ commit }, data) {
  try {
    const response = await axios.get(`/issuer/kyc/list`, {
      params: data,   // 👈 must send as query params
    });

    if (response.data?.object) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},

async kycDetails({ commit }, data) {
  try {
    const response = await axios.post(`/issuer/kyc/address`, data);

    if (response.data?.object) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},


async kycApproveBlob({ commit }, data) {
  try {
    const response = await axios.post(`/issuer/kyc/approve/blob`, data);

    if (response.data?.object) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},

async kycApproveSubmit({ commit }, data) {
  try {
    const response = await axios.post(`/issuer/kyc/approve/submit`, data);

    if (response.data?.object) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},


async kycReject({ commit }, data) {
  try {
    const response = await axios.post(`/issuer/kyc/reject`, data);

    if (response.data?.object) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},

async vcPassAdminApproval({ commit }, payload) {
  try {
    // send payload directly, not wrapped
    const response = await axios.post(`/issuer/pass-design/admin/approval`, payload);

    if (response.data?.object) {
      return response.data
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},

async certRevokeBlob({ commit }, data) {
  try {
    const response = await axios.post(`/issuer/certificate/vc/revoke/blob`, data);

    if (response.data?.object) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},


async certRevokeSubmit({ commit }, certListData) {
  try {
    const response = await axios.post(`/issuer/certificate/vc/revoke/submit`, certListData);

    if (response.data?.object) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},

async vcPassCreateBatch({ commit }, data) {
  try {
    // data should be an array of pass design objects
    const response = await axios.post(`/issuer/pass-design/create-batch`, data);

    if (response.data?.object) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},


async vcListPassbyTemplateId({ commit }, templateId) {
  try {
    const response = await axios.get(`/issuer/pass-design/list-by-template`, {
      params: { templateId }
    });

    if (response.data?.object) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},


async vcPassAdminApprovalBatch({ commit }, payload) {
  try {
    const response = await axios.post(`/issuer/pass-design/admin/approval-batch`, payload);

    if (response.data?.object) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},

async vcPassIssuerApproveBatch({ commit }, payload) {
  try {
    const response = await axios.post(`/issuer/pass-design/issuer/approve-batch`, payload);

    if (response.data?.object) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},

async vcPassDetailsByDesignPassId({ commit }, passDesignId) {
  try {
    const response = await axios.get(`/issuer/pass-design/detail-by-id`, {
      params: { passDesignId }
    });

    if (response.data?.object) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},

async vcPassUpdate({ commit }, data) {
  try {
    const response = await axios.post(`/issuer/pass-design/update`, data);

    if (response.data?.object) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},


async editTemplateAttributes({ commit }, payload) {
  try {
    const response = await axios.post(`/issuer/template/edit-attributes`, payload);
    if (response.data?.object) {
      return response.data;
    }
    return null;
  } catch (error) {
    if (error.response?.data?.messages?.[0]) {
      return error.response.data.messages[0];
    }
    throw error;
  }
},
};